import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import BottomNav from "./components/BottomNav";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import HomePage from "./pages/HomePage";
import UploadPage from "./pages/UploadPage";
import AccountPage from "./pages/AccountPage";
import TasksPage from "./pages/TasksPage";
import DocumentDetailPage from "./pages/DocumentDetailPage";
import AdminPage from "./pages/AdminPage";
import AdminEditButton from "./components/AdminEditButton";
import TranscriberDashboard from "./pages/TranscriberDashboard";
import TranscriptionWorkspace from "./pages/TranscriptionWorkspace";
import DocumentEditorPage from "./pages/DocumentEditorPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import { Loader2 } from "lucide-react";
import AdminMessageInbox from "./components/AdminMessageInbox";
import WalletStatus from "./components/WalletStatus";
import AndroidDownloadBanner from "./components/AndroidDownloadBanner";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 size={32} className="animate-spin text-[var(--brand-primary)]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AuthRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 size={32} className="animate-spin text-[var(--brand-primary)]" />
      </div>
    );
  }
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<AuthRoute><LoginPage /></AuthRoute>} />
        <Route path="/register" element={<AuthRoute><RegisterPage /></AuthRoute>} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/verify-email" element={<ProtectedRoute><VerifyEmailPage /></ProtectedRoute>} />
        <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
        <Route path="/upload" element={<ProtectedRoute><UploadPage /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
        <Route path="/tasks" element={<ProtectedRoute><TasksPage /></ProtectedRoute>} />
        <Route path="/document/:id" element={<ProtectedRoute><DocumentDetailPage /></ProtectedRoute>} />
        <Route path="/workspace/:id" element={<ProtectedRoute><TranscriptionWorkspace /></ProtectedRoute>} />
        <Route path="/editor/:id" element={<ProtectedRoute><DocumentEditorPage /></ProtectedRoute>} />
        <Route path="/transcriber" element={<ProtectedRoute><TranscriberDashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BottomNav />
      <AdminEditButton />
      <AdminMessageInbox />
      <WalletStatus />
      <AndroidDownloadBanner />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
